import React from 'react';
import ReactDOM from 'react-dom/client';
import {GoogleOAuthProvider} from '@react-oauth/google';
import './index.css';

import reportWebVitals from './reportWebVitals';
import App from "./App";
import {ToastProvider} from "./hooks/useToast";
import SocketProvider from "./context/SocketContext";
import {store} from "./store";
import {Provider} from "react-redux";
import {I18nProvider} from "./i18n";

// if (process.env.NODE_ENV !== 'production') {
//     // Import only in dev
//     require('./debug/monkeyPatchReactCreateElement');
// }

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <GoogleOAuthProvider clientId="35775291425-r4pc06nsn2jnamk8i518flme5enciqav.apps.googleusercontent.com">
        <React.StrictMode>
            <Provider store={store}>
                <I18nProvider>
                    <SocketProvider>
                        <ToastProvider>
                            <App/>
                        </ToastProvider>
                    </SocketProvider>
                </I18nProvider>
            </Provider>
        </React.StrictMode>
    </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
